import styled from "styled-components";
import { colors } from "@/theme";

export const ShippingFeeContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  height: 40px;
  padding: 12px 16px;
  align-items: center;
  column-gap: 12px;
`;

export const ShippingFeeLabel = styled.div`
  color: ${colors.fieldTextHelper};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ShippingFeeValue = styled.div`
  justify-self: end;
  align-self: center;
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;
